"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = void 0;
var _Log = require("../../constants/Log");
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2022-09-30 10:18:18
 */

const log = async function (description, module) {
  let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Log.LogLevel.INFO;
  let type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Log.LogType.USER;
  let data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let token = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  let user_login = arguments.length > 6 ? arguments[6] : undefined;
  const logData = {
    description: description,
    module: module,
    level: level,
    type: type,
    data: data,
    user_login: user_login
  };
  if (!token) {
    throw new Error("[No Token] Could not log action");
  }
  (0, _DmsFetch.fetchData)("/log", "POST", token, logData).then(result => {
    if (result.status !== 200 && result.status !== 201) {
      throw result.data.detail;
    }
  }).catch(result => {
    if (Array.isArray(result)) {
      for (const i of result) {
        throw new Error("Could not log action: ".concat(i.msg, " in ").concat(i.loc[1]));
      }
    } else {
      throw new Error("Could not log action: ".concat(result));
    }
  });
};
exports.log = log;